<!--
 * @Author: your name
 * @Date: 2021-10-25 14:55:48
 * @LastEditTime: 2021-11-15 15:56:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\Xunzhangshu_Website\xzswebsite\src\components\home.vue
-->
<template>
  <div class="bigBox">
    <div class="topBox">
      <div class="title">
        <div>
          <img src="../assets/img/xzs_logo.png" />
          <span style="color:#fff;">勋章树</span>
        </div>
        <div>
          <div>
            <span @click="toHomePage=>{this.$router.push('/')}">首页</span>
          </div>
          <!-- <div>
            <span @click="toEnterprise">企业服务</span>
          </div>-->
          <div>
            <span>关于我们</span>
          </div>
          <!-- <div>
            <span @click="toJoin">加入我们</span>
          </div>-->
        </div>
      </div>
      <div class="aboutUs">
        <span>关于我们</span>
      </div>
    </div>
    <div class="content">
      <div>
        <p>关于勋章树</p>
        <p>About the medal tree</p>
        <p>勋章树成立于2021年，由霍潇如在上海创立。勋章树致力于为个人用户与企业用户提供认知升级，以独特的勋章升级方式</p>
        <p>据美国政治新闻网站Politico24日报道，共和党参议院全国委员会已向竞选机构发送了一份长达57页的备忘录，建议共和党候选人通过积极攻击中国来应对新冠疫情危机。</p>
        <p>虽然中国的疫情目前得到控制，经济开始恢复，但是如果其他国家疫情不解决，经济不恢复，中国的疫情不可能完全控制，经济也不可能完全恢复。近日，中国有100名学者发表联名倡议，美国也有近百名学者高官联合呼吁放下成见，加强合作，携手抗击疫情。</p>
      </div>
    </div>
    <div class="map">
      <div>
        <p>联系我们</p>
        <p>contact us</p>
      </div>
      <div>
        <img src="../assets/img/map.png" style="width:792px;height:594px;" />
        <div>
          <p>地址：上海市闵行区燎申国际大厦5F、G室</p>
          <p>邮箱：ad@seasfly.com</p>
          <p>联系电话：021-64051039</p>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div>
        <div>
          <div style="color:#fff;">
            <span>服务协议</span>
            <span>隐私协议</span>
            <span>关于我们</span>
            <span>加入我们</span>
          </div>
          
          <div>
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              style="color:#f14016;"
            >沪ICP备2021032438号</a> Copyright 上海士鸢信息科技有限公司 | 地址 : 上海市闵行区燎申国际大厦5楼F、G室
          </div>
          <div>联系电话：021-64051039 | 邮箱:ad@seasfly.com</div>
        </div>
        <div class="code">
          <div>
            <img src="../assets/img/ioscode.png" style="width:96px;height:96px;" />
            <p>
              <img src="../assets/img/iOS_mini.png" style="width:22px;height:22px;" />
              <span>iOS 版</span>
            </p>
          </div>
          <div>
            <img src="../assets/img/androidcode.png" style="width:96px;height:96px;" />
            <p>
              <img src="../assets/img/Android_mini.png" style="width:22px;height:22px;" />
              <span>Android 版</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: ""
    };
  },
  methods: {
    toEnterprise() {
      this.$router.push("enterprise");
    },
    toAbout() {
      this.$router.push("about");
    },
    toJoin() {
      this.$router.push("join");
    }
  },
  mounted() {}
};
</script>

<style scoped lang='less'>
a {
  text-decoration: none;
}

body {
  width: 100%;
  height: 100vh;
}
.bigBox {
  width: 100%;
  .topBox {
    width: 100%;
    min-height: 500px;
    // background-image: url("../assets/img/backgroundImage.png");
    background-image: url("../assets/img/backgroundImage.jpeg");
    background-position: 0 -500px;
    background-size: 100% 1080px;
    background-repeat: no-repeat;
    .aboutUs {
      width: 100%;
      height: 430px;
      color: #fff;
      font-size: 48px;
      font-weight: bold;
      margin: 0 auto;
      text-align: center;
      line-height: 380px;
    }
  }
  .title {
    max-width: 1280px;
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    font-size: 18px;
    z-index: 999;
    img {
      width: 40px;
      height: 40px;
      margin-right: 16px;
    }
    > div {
      display: flex;
      height: 30px;
      align-items: center;
    }
    > div:nth-child(2) {
      > div {
        margin-right: 48px;
        color: #c4c4c4;
        cursor: pointer;
      }
      > div:last-child {
        color: #fff;
        border-bottom: 2px solid #fff;
      }
      > div:last-child {
        margin-right: 0;
      }
    }
  }
  .content {
    width: 100%;
    height: 600px;
    margin: 0 auto;
    background: #fff;
    padding-top: 112px;
    > div {
      margin: 0 auto;
      p {
        width: 1000px;
        margin: 0 auto;
        font-size: 18px;
        font-family: PingFangSC;
        font-weight: 400;
        color: #333333;
        text-align: center;
      }
      > p:nth-child(1) {
        font-size: 36px;
        font-family: PingFangSC;
        font-weight: 500;
        color: #333333;
      }
      > p:nth-child(2) {
        font-size: 18px;
        font-family: PingFangSC;
        font-weight: 400;
        line-height: 21px;
        color: #999999;
        margin-bottom: 72px;
      }
      > p:nth-child(3) {
        margin-bottom: 40px;
        text-align: left;
      }
      > p:nth-child(4) {
        margin-bottom: 40px;
        text-align: left;
      }
      > p:nth-child(5) {
        margin-bottom: 40px;
        text-align: left;
      }
    }
  }
  .map {
    width: 100%;
    // height: 900px;
    padding-top: 112px;
    background: #f8f8f8;
    padding-bottom: 40px;
    > div:nth-child(1) {
      width: 1200px;
      margin: 0 auto;
      > p {
        margin: 0 auto;
        text-align: center;
      }
      > p:nth-child(1) {
        font-size: 36px;
        font-family: PingFangSC;
        font-weight: 500;
        color: #333333;
      }
      > p:nth-child(2) {
        font-size: 18px;
        font-family: PingFangSC;
        font-weight: 400;
        color: #999999;
      }
    }
    > div:nth-child(2) {
      position: relative;
      width: 1200px;
      margin: 0 auto;
      text-align: left;
      > div {
        box-sizing: border-box;
        position: absolute;
        top: 115px;
        right: 0;
        width: 486px;
        height: 365px;
        background: #ffffff;
        box-shadow: 0px 1px 12px rgba(0, 0, 0, 0.1);
        padding: 129px 0 129px 47px;
        > p {
          font-size: 18px;
          font-family: PingFangSC;
          font-weight: 400;
          color: #333333;
          margin-bottom: 16px;
        }
      }
    }
  }
  .bottom {
    // position: absolute;
    // bottom: 0;
    // left: 50%;
    // transform: translateX(-50%);
    width: 100%;
    height: 300px;
    background: #000000;
    margin: 0 auto;
    font-size: 14px;
    font-family: PingFangSC;
    color: #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    
    > div {
      width: 950px;
      margin: 0 auto;
      display: flex;
      > div {
        text-align: left;
      }
      > div:nth-child(1) {
        width: 680px;
        > div:nth-child(1) {
          display: flex;
          justify-content: space-between;
          margin-bottom: 40px;
        }
      }
      .code {
        display: flex;
        margin-left: 288px;
        p {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        > div:nth-child(2) {
          margin-left: 16px;
        }
      }
    }
  }
}
</style>
